import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-entities/data-entities/$projId/explore/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.DATA_UNIFICATION_ENTITIES });
    context.validatePermissions({ isAllowed, preload });
  },
});
